import { IProduct } from "../types";

const getVatAmountForLineItem = (lineItem: IProduct): number => {
  return lineItem.vatIncluded ? calculateVATForPrice(Number(lineItem.price)) * Number(lineItem.lineItemQuantity) : 0;
};

const getTotalAmountForLineItem = (lineItem: IProduct): number => {
  return Number(lineItem.price) * Number(lineItem.lineItemQuantity);
};

const getTotalAmountForLineItemArray = (lineItemInformationArray: Array<IProduct>): number => {
  return lineItemInformationArray
    ? lineItemInformationArray.reduce((acc, obj) => Number(acc) + getTotalAmountForLineItem(obj), 0)
    : 0;
};

const getTotalVatAmountForLineItemArray = (lineItemInformationArray: Array<IProduct>): number => {
  return lineItemInformationArray
    ? lineItemInformationArray.reduce((acc, obj) => Number(acc) + getVatAmountForLineItem(obj), 0)
    : 0;
};

const convertCentsToRand = (cents: number): number => {
  return cents / 100;
};

const calculateTotalFromProductList = (array: any[]): string => {
  let total = 0;
  array.forEach(item => {
    total += item.price * item.quantity;
  });
  return total.toFixed(2);
};

const calculateVATForPrice = (price: number): number => {
  const vatRate = 1.15;

  return price - Number((price / vatRate).toFixed(0));
};

export {
  getTotalAmountForLineItem,
  getVatAmountForLineItem,
  getTotalAmountForLineItemArray,
  getTotalVatAmountForLineItemArray,
  convertCentsToRand,
  calculateTotalFromProductList,
  calculateVATForPrice,
};
